//Geneal
import React, { useMemo } from "react";
import { useQueries } from 'react-query'
import { useQueryClient } from "react-query";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

//Owner
import Label from "components/general/Label"
import Loader from 'components/general/Loader'
import MirsTable from "components/general/table/Table";
import CaptionTable from "components/general/table/CaptionTable";
import LoaderSubComponent from "components/general/LoaderSubComponent";
import { useViewport } from 'components/general/useViewPort'
import { getRscObject } from "helpers/rsc";
import { getResultsPhase, getResultsRSC } from "data/Querys"
import NotAvailable from 'components/common/NotAvailable'
import { TableColumns as Columns, TableColumnsStartList as columnStartList } from 'components/sports/gar/events/apparatus/Columns'
import { TableExpanded } from 'components/sports/gar/events/rotations/TableExpanded'
import { isIndFinalApparatus, getApparatusFromEvent } from "components/sports/gar/helper/GarHelpers";
import { isStartListStatus } from "helpers/status";
import GarCurrent from "../events/apparatus/Current";
import GarPrevious from "../events/apparatus/Previous";
import Status from "components/presentation/Status";
import SportCode from "components/common/SportCode";
import ProgressionRule from "components/common/ProgressionRule";
import { isLiveStatus } from "helpers/status";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

const GarApparatus = ({ apparatus }) => {
    //-------------------- DATA ---------------------------//
    const { mirs_competition, mirs_rsc, mirs_language, mirs_discipline } = useUrlFriendlyToParameters()
    const rscObj = getRscObject(mirs_rsc)
    const _isIndFinalApparatus = isIndFinalApparatus(mirs_rsc);
    const discipline = mirs_discipline;


    let queryArray = [];
    apparatus.forEach((item) => {
        let event = "1AP" + item + "-------------";
        let rsc = rscObj.discipline + rscObj.sex + event + rscObj.phase;
        let query = getResultsPhase
        if (_isIndFinalApparatus) {
            rsc = rscObj.discipline + rscObj.sex + event + rscObj.phase + rscObj.unit;
            query = getResultsRSC
        }


        queryArray.push({
            queryKey: ['resultsApparatus', mirs_competition, rsc, mirs_language],
            queryFn: query,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        })
    });


    apparatus.forEach((item) => {
        let event = "1AP" + item + "-------------";
        let rsc = rscObj.discipline + rscObj.sex + event + "QUAL";
        let query = getResultsPhase
        queryArray.push({
            queryKey: ['resultsApparatusQual', mirs_competition, rsc, mirs_language],
            queryFn: query,
            refetchInterval: 0,
            staleTime: Infinity,
            refetchIntervalInBackground: true,
            //_isIndFinalApparatus
        })
    });




    const results = useQueries(queryArray);
    const isLoading = results.some(result => result.isLoading)
    const isError = results.some(result => result.isError)

    if (isError) { return <NotAvailable />; }
    if (isLoading) { return <Loader />; }
    //------------------------------------------
    //Draw apparatus navigator
    let elements = []
    Array.isArray(apparatus) && apparatus.forEach((item) => {
        let lbleApparatus = <SportCode discipline={discipline} entity='@Apparatus' code={item} />

        elements.push(
            <Tab key={`mirs-gar-apparatus-item-${item}`} eventKey={item} title={lbleApparatus}>
                <ResultApparatus apparatus={item} isIndFinalApparatus={_isIndFinalApparatus} rsc={mirs_rsc} />
            </Tab>
        )
    })


    let apparatusFromRsc = getApparatusFromEvent(rscObj.event)
    let indexApparatus = apparatus.indexOf(apparatusFromRsc)
    let defaultApparatus = _isIndFinalApparatus ? apparatus[indexApparatus] : apparatus[0]
    return (
        <>
            <Tabs
                defaultActiveKey={defaultApparatus}
                id="mirs-gar-apparatus"
                className="mb-3"
                justify
                variant="pills"
            >
                {elements}
            </Tabs>
        </>
    )
};

const ResultApparatus = ({ apparatus, isIndFinalApparatus, rsc }) => {
    let data = useGetData(apparatus);
    let resultStatus
    let scheduleStatus
    const { breakPoint } = useViewport();
    const rscObj = getRscObject(rsc)
    let rscId;
    let items;

    if (isIndFinalApparatus) {
        rscId = data?.results?.eventUnitCode;
        items = data?.results?.items;
        resultStatus = data?.results?.status?.code;
        scheduleStatus = data?.results?.schedule?.status?.code;

    } else {
        rscId = data?.phaseResults && data?.phaseResults[0]?.phaseCode;
        items = data?.phaseResults && data?.phaseResults[0].items;
        resultStatus = data?.phaseResults && data?.phaseResults[0]?.status?.code;
        //scheduleStatus = data?.phaseResults && data?.phaseResults[0]?.schedule?.status?.code;
        //Provisional get real sschedule status when bring it in query
        scheduleStatus = data?.results?.schedule?.status?.code;
    }


    //Cuando cambimos de estado de resultados forzamos a repintar la tabla con las nuevas columnas 
    //aunque no hay cambios    
    // eslint-disable-next-line
    const configEvent = useMemo(() => getConfiguration(resultStatus, scheduleStatus, rsc, breakPoint), [breakPoint, resultStatus]);

    // Create a function that will render our row sub components
    const renderRowSubComponent = React.useCallback(({ row }) => (
        <LoaderSubComponent component={
            <TableExpanded row={row?.original} />
        }
        />
        // eslint-disable-next-line
    ), []);




    let swQualRules = (rscObj.phase.indexOf("QUAL") > -1) ? true : undefined

    let noData = []
    let dataRow = items ? items : noData



    return (
        <>
            {swQualRules &&
                <ProgressionRule
                    key="progress-component"
                    data={data?.config}
                    filter={{ type: ['QUALIFICATION'], code: ['QUAL_RULE'] }}
                />}

            <>
                {isIndFinalApparatus && items && <GarPrevious data={data} apparatus={apparatus} />}
                {isIndFinalApparatus && items && <GarCurrent data={data} apparatus={apparatus} />}

                < MirsTable
                    //Dato to show by row
                    data={dataRow}
                    //Columnas a visualizar 
                    columns={configEvent.columns}
                    //subcomponente a renderizar, extended
                    renderRowSubComponent={renderRowSubComponent}
                    //Key by row necesary in order to no paint innecesary
                    //keyRow='participant-code'
                    //Component caption
                    caption={configEvent.caption}
                    //Columns to hidde 
                    //hiddenColumns={hiddenColumns}
                    //When show tble is sorted by 
                    initialSortBy={configEvent.sortBy}
                    id={`mirs-table-apparatus-result-${rscId}-${apparatus}`}
                    classCaption={isLiveStatus(resultStatus) ? 'currentIndicator' : ''}
                    getRowProps={row => {
                        //Higthlight last competitor 
                        let isCurrent = Array.isArray(row.original?.extendedResultsCurrent) &&
                            row.original?.extendedResultsCurrent?.find(item =>
                                item.er_code === 'STAGE' &&
                                item.er_type === 'ER' &&
                                item.er_value === "CURRENT") &&
                            row.original?.extendedResultsCurrent.length > 0
                        return {
                            className: isCurrent ? 'currentIndicator' : '',
                        }
                    }}
                />
            </>


        </>
    );
}

function useGetData(apparatus) {
    const { mirs_rsc, mirs_competition, mirs_language } = useUrlFriendlyToParameters()
    const rscObj = getRscObject(mirs_rsc)
    const _isIndFinalApparatus = isIndFinalApparatus(mirs_rsc);

    let event = "1AP" + apparatus + "-------------";
    let rsc = rscObj.discipline + rscObj.sex + event + rscObj.phase;
    if (_isIndFinalApparatus) {
        rsc = rscObj.discipline + rscObj.sex + event + rscObj.phase + rscObj.unit;
    }

    let query = ['resultsApparatus', mirs_competition, rsc, mirs_language]
    const queryClient = useQueryClient();
    const data = queryClient.getQueryData(query);

    return data
}

const getConfiguration = (resultStatus, scheduleStatus, rsc, breakPoint) => {


    let configuration = {
        caption: null,
        columns: [],
        //subComponent: null,
        hiddenColumns: [],
        sortBy: [],
    };

    configuration.caption = <CaptionTable
        leftCol={isIndFinalApparatus(rsc) && <h4 className="text-dark"><Label data={"LabelResults"} /></h4>}
        rightCol={<Status typeToPrint="result" scheduleStatus={scheduleStatus} resultStatus={resultStatus} />}
    />

    configuration.sortBy = [{ id: 'Rank', desc: false }]

    configuration.sortBy = isIndFinalApparatus(rsc) && isStartListStatus(resultStatus)
        ? [{ id: 'Bib', desc: false }]
        : [{ id: 'Rank', desc: false }]


    configuration.columns = isIndFinalApparatus(rsc) && isStartListStatus(resultStatus)
        ? columnStartList()
        : Columns()

    return configuration;
};

export default GarApparatus;


